import styled from 'styled-components';

const Wrapper = styled.section`
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;

    padding: 40px 20px;

    display: flex;
    align-items: center;
    flex-direction: column;

    position: relative;
`

export default Wrapper;